import request from '@/utils/request'
import { encryptPassword } from '@/utils/rsa-encrypt'

const userApi = {
  Login: '/login',
  Logout: '/logout',
  Register: '/register',
  // get my info
  UserInfo: '/get-user-info'
}

export function login (accountNo, password, smsCode, uuid, userType, loginType, device) {
  // 对密码进行加密
  const encryptedPassword = encryptPassword(password)
  
  const data = {
    accountNo,
    password: encryptedPassword, // 使用加密后的密码
    smsCode,
    uuid,
    userType,
    loginType,
    device
  }
  return request({
    url: userApi.Login,
    method: 'post',
    data: data
  })
}

// 注册方法
export function register (data) {
  return request({
    url: userApi.Register,
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

export function getInfo () {
  return request({
    url: userApi.UserInfo,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function logout () {
  return request({
    url: userApi.Logout,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 获取验证码
export function getCodeImg () {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}
